import $ from 'jquery';

export default class PendingRegistrationCheck {
  constructor($scope, UserService, UserContactService) {
    $scope.similarity_tabs = UserService.get_similar_tabs();

    $scope.compare_tabs = UserService.get_similar_dialog_tabs();

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
      $scope.filtered_similar_users = $scope.get_filtered_similar_users(index);
    };

    $scope.set_selected_compare_tab = function(index) {
      $scope.selected_compare_tab = index;
    };

    $scope.get_filtered_similar_users_length = function(index) {
      if (index == 0)
        return $scope.similar_users.length;
      else
        return $scope.get_filtered_similar_users(index).length;
    };

    $scope.get_filtered_similar_users = function(index) {
      return UserService.get_filtered_similar_users($scope.similar_users, index);
    };

    $scope.mark_as_not_similar = function() {
      $scope.similar_users.splice($scope.similar_users.indexOf($scope.compare_user), 1);
      $scope.filtered_similar_users = $scope.get_filtered_similar_users($scope.selected_tab);
      $.fancybox.close();
    };

    $scope.create_from_pending = function() {
      UserService.create_from_pending(window.pending_registration.pending_registration.id).then(function(data) {
        if (data.success) {
          $scope.created_user_id = data.user_id;
          $scope.create_mode = false;
          $scope.form_error = '';
          $.fancybox.close();
        } else {
          $scope.form_error = data.message;
        }
      });
    };

    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.compare_users = function(user) {
      $scope.compare_user = user;
      $scope.open_dialog('compare_user_dialog');
    };

    $scope.set_update_mode = function(value) {
      $scope.update_mode = value;
      $scope.updating_user = '';
    };

    $scope.update_field = function(value, property) {
      $scope.updating_user = true;
      var update_data = {
        id: $scope.compare_user.id
      };

      if (property == 'email')
        update_data['company_email'] = value;
      else if (property == 'vat')
        update_data['ssn'] = value;
      else if (property == 'country_id')
        update_data['country_id'] = value;
      else if (property == 'city_id')
        update_data['city_id'] = value;
      else if (property == 'phone')
        update_data['phone'] = value;
      else if (property == 'fax')
        update_data['fax'] = value;

      UserService.update(update_data, null, null).then(function(data) {
        if (data.success) {
          $scope.update_error = '';
          $scope.compare_user[property] = value;
        } else {
          $scope.update_error = data.message;
        }
        $scope.updating_user = false;
      });
    };

    $scope.add_contact_to_similar = function() {
      $scope.updating_user = true;
      var contact = $scope.user.user_contacts_attributes[0];
      contact['user_id'] = $scope.compare_user.id;
      contact['account'] = $scope.account;
      contact['account']['status'] = 'pending';
      UserContactService.save(contact).then(function(data) {
        if (data.success) {
          $scope.update_error = 'Contact added!';
        } else {
          $scope.update_error = 'Contact: ' + data.message;
        }
        if (data.account_success) {
          $scope.update_error += ', Account added!';
        } else {
          $scope.update_error += ', Account: ' + data.account_message;
        }
        $scope.updating_user = false;
      });
    };

    $scope.update_contact = function(contact) {
      $scope.updating_user = true;
      UserContactService.update_similar_contact($scope.user.user_contacts_attributes[0], $scope.account, contact.id).then(function(data) {
        if (data.success) {
          $scope.update_error = 'Contact updated!';
        } else {
          $scope.update_error = 'Contact: ' + data.message;
        }
        if (data.account_success) {
          $scope.update_error += ', Account added!';
        } else {
          $scope.update_error += ', Account: ' + data.account_message;
        }
        $scope.updating_user = false;
      });
    };

    $scope.init = function() {
      $scope.create_mode = true;
      $scope.update_mode = false;
      $scope.selected_tab = 0;
      $scope.selected_compare_tab = 0;
      $scope.similar_users = window.similar_users;
      $scope.filtered_similar_users = window.similar_users;
      $scope.user = window.pending_registration.pending_registration.data.user;
      $scope.account = window.pending_registration.pending_registration.data.account;
      $scope.business_relations = window.business_relations;
    };

    $scope.init();
  }
}

PendingRegistrationCheck.$inject = ['$scope', 'UserService', 'UserContactService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/pending-registration-check.ctrl.js